import React, { useState, useEffect } from 'react';
import { Activity, Clock, User, Search } from 'lucide-react';

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const res = await fetch('/api/invoice/audit');
      const data = await res.json();
      setLogs(data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const filteredLogs = logs.filter(log => 
    log.action.toLowerCase().includes(searchTerm.toLowerCase()) ||
    log.moduleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (log.metadata && log.metadata.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  if (loading) return <div style={{ textAlign: 'center', padding: '2rem' }}>Loading system logs...</div>;

  return (
    <div className="form-section animate-fade-in">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
            <h3 className="section-title" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', margin: 0, border: 'none' }}>
                <Activity size={20} className="text-secondary" /> System Audit Trails
            </h3>

            <div style={{ position: 'relative', width: '350px' }}>
                <Search size={16} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
                <input 
                    type="text" 
                    placeholder="Search logs by action, invoice, or user..." 
                    className="premium-input" 
                    style={{ paddingLeft: '36px', height: '42px' }}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
        </div>
        
        <div style={{ maxHeight: '600px', overflowY: 'auto', border: '1px solid var(--border-color)', borderRadius: '12px' }}>
            <table className="premium-table">
                <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                    <tr>
                        <th style={{ width: '180px' }}>Timestamp</th>
                        <th>User Action</th>
                        <th>Module</th>
                        <th>Metadata / ID</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredLogs.map(log => (
                        <tr key={log.id}>
                            <td style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                                    <Clock size={12} /> {new Date(log.timestamp).toLocaleString()}
                                </div>
                            </td>
                            <td>
                                <div style={{ fontWeight: '600', color: '#0f172a', fontSize: '0.9rem' }}>{log.action}</div>
                                <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: '0.3rem', marginTop: '2px' }}>
                                    <User size={10} /> Operator ID: {log.userId || 'System'}
                                </div>
                            </td>
                            <td>
                                <span style={{ padding: '0.2rem 0.6rem', borderRadius: '6px', fontSize: '0.65rem', fontWeight: '800', background: '#f1f5f9', color: '#64748b', textTransform: 'uppercase' }}>
                                    {log.moduleName}
                                </span>
                            </td>
                            <td style={{ fontSize: '0.75rem', color: '#64748b', maxWidth: '250px' }}>
                                <code style={{ background: '#f8fafc', padding: '2px 4px', borderRadius: '4px' }}>
                                    {log.metadata || 'N/A'}
                                </code>
                            </td>
                        </tr>
                    ))}
                    {filteredLogs.length === 0 && (
                        <tr>
                            <td colSpan="4" style={{ textAlign: 'center', padding: '4rem', color: 'var(--text-muted)' }}>
                                {searchTerm ? `No logs found matching "${searchTerm}"` : "No audit trails recorded yet."}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    </div>
  );
};

export default AuditLogs;
